import { useTypedDispatch } from '@/redux/helpers/hooks.ts';
import { postCartItem } from '@/redux/slices/user/thunks/postCartItem.ts';
import { useState } from 'react';
import { IFormInput } from '@template/components/Form';
import { Form } from '@template/components';

const NumberTransferTab = () => {
  const dispatch = useTypedDispatch();

  const [formValue, setFormValue] = useState({
    number: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const inputs: IFormInput[] = [
    {
      label: 'Number to transfer',
      name: 'number',
      error,
    },
  ];

  const handleChange = (vals: any) => {
    setFormValue(vals);
    setError('');
  };

  const addNumberToCart = async () => {
    if (loading) return;

    setLoading(true);
    await dispatch(
      postCartItem({
        itemType: 15,
        itemSubType: 0,
        itemData: {
          number: formValue.number,
        },
      })
    ).then((r: any) => {
      if (r.error) {
        setError(r.payload);
      }
    });

    setLoading(false);
  };

  return (
    <>
      <Form
        value={formValue}
        onChange={handleChange}
        inputs={inputs}
        simple
        submit={{
          text: 'Add Transfer',
          style: {
            width: 'fit-content',
            marginLeft: 'auto',
          },
          size: 'md',
          loading: loading,
          onSubmit: addNumberToCart,
        }}
      />
    </>
  );
};

export default NumberTransferTab;
